/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import SimpleTooltip from '../../simple-tooltip';
import { Button } from 'reactstrap';
import React, { useState } from 'react';
import { SurveyModelMinData } from '../../../model/surveyData';
import { BlockingLoader } from '../../loader/BlockingLoader';
import { useToggleCompleteSurveys } from '../../../hooks/useToggleCompleteSurveys';
import { CompleteSurveyModal } from '../../complete-survey-modal';

interface Props {
  isUserAdmin: boolean;
  survey: Pick<SurveyModelMinData, 'completedDate' | '_id' | 'initiativeId'>;
  handleReload: () => Promise<any>;
  className?: string;
  color?: 'link';
}

export const CompleteButton = (props: Props) => {
  const { isUserAdmin, survey, handleReload, className, color } = props;
  const isComplete = Boolean(survey.completedDate);
  const { isSaving, toggleCompleteSurveys } = useToggleCompleteSurveys({
    handleReload,
    surveys: [survey],
    isCompleting: !isComplete,
  });
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggle = () => setIsOpen(!isOpen);

  const onClickComplete = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    return toggle();
  };


  if (!isUserAdmin) {
    if (isComplete) {
      return <span className='mr-3 text-ThemeTextPlaceholder'><i className='fa fa-lock mr-2' />Completed</span>;
    }
    return null;
  }

  const completedTooltip = isComplete ? 'Click to unlock the survey' : 'This will lock your survey to stop new data being added. You can unlock anytime.';
  return (
    <>
      {isSaving ? <BlockingLoader /> : null}
      <SimpleTooltip text={completedTooltip}>
        <Button
          color={color ?? (isComplete ? 'success' : 'secondary')}
          disabled={!isUserAdmin}
          defaultChecked={isComplete}
          onClick={isComplete ? toggleCompleteSurveys : onClickComplete}
          className={`complete-btn ml-2 px-3 ${className}`}
        >
          {isComplete ? <><i className='fa fa-lock mr-2' />Completed</> : 'Mark as complete'}
        </Button>
      </SimpleTooltip>
      <CompleteSurveyModal
        isOpen={isOpen}
        toggle={toggle}
        completeSurveyCallback={toggleCompleteSurveys}
      />
    </>
  );
}
